import type { DesfazerAlteracaoProps } from "./types-desfazer-alteracao";
import { useDesfazerAlteracao } from "./use-desfazer-alteracao";
import { DesfazerAlteracaoView } from "./view-desfazer-alteracao";

/** "Desfazer alteração" (ícone), com confirmação. O cartão Removido não tem ação própria (Figma 9651:41026). */
export function DesfazerAlteracao(props: DesfazerAlteracaoProps) {
  const vm = useDesfazerAlteracao(props);

  return <DesfazerAlteracaoView {...vm} />;
}

export type * from "./types-desfazer-alteracao";
